import ClearIcon from "@mui/icons-material/Clear";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import {PuiGrid, PuiSearchPage, PuiTableAction} from "@portnet/ui";
import useAlert from "@portnet/ui/dist/hooks/useAlert";
import download from "downloadjs";
import {Form, Formik} from "formik";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import AppAutocomplete from "../../../../common/components/inputs/AppAutocomplete";
import AppDateField from "../../../../common/components/inputs/AppDateField";
import AppSimplePopupReferentielField from "../../../../common/components/inputs/AppSimplePopupReferentielField";
import AppSimpleReferentielField from "../../../../common/components/inputs/AppSimpleReferentielField";
import AppSpecificReferentielField from "../../../../common/components/inputs/AppSpecificReferentielField";
import AppTextField from "../../../../common/components/inputs/AppTextField";
import AppButton from "../../../../common/components/ui/AppButton";
import AppDialog from "../../../../common/components/ui/AppDialog";
import AppSection from "../../../../common/components/ui/AppSection";
import useLocalReferentiel from "../../../../common/hooks/useLocalReferentiel";
import usePagination from "../../../../common/hooks/usePagination";
import * as localReferentielKeys from "../../../../common/localReferentiel/others/localReferentielKeys";
import HistoriqueSouscription from "../../../souscriptions/historiqueSouscription/page/HistoriqueSouscription";
import * as consultationTransactionsFormNames from "../others/consultationTransactionsFormNames";
import {
  annulationTransactionInitialValues,
  consultationTransactionsInitialValues,
} from "../others/consultationTransactionsInitialValues";
import {consultationTransactionsTableColumns} from "../others/consultationTransactionsTableColumns";
import {
  annulationTransactionValidationSchema,
  consultationTransactionsValidationSchema,
} from "../others/consultationTransactionsValidationSchemas";
import {
  annulationTransactionAction,
  annulationTransactionReinitializationAction,
  excelExport,
  getConsultationTransactionsListAction,
  printReinitialization,
} from "../state/consultationTransactionsActions";

const OPEN_ANNULATION_DIALOG_REDUCER_TYPE = "OPEN_ANNULATION_DIALOG";
const CLOSE_ANNULATION_DIALOG_REDUCER_TYPE = "CLOSE_ANNULATION_DIALOG";

const annulationInitialState = {
  isAnnulationDialogOpen: false,
  transactionToCancel: null,
};

const annulationReducer = (state, { type, transactionToCancel }) => {
  switch (type) {
    case OPEN_ANNULATION_DIALOG_REDUCER_TYPE:
      return {
        isAnnulationDialogOpen: true,
        transactionToCancel,
      };
    case CLOSE_ANNULATION_DIALOG_REDUCER_TYPE:
      return {
        isAnnulationDialogOpen: false,
        transactionToCancel: null,
      };

    default:
      throw new Error("Annulation reducer : Type invalide");
  }
};

const ConsultationTransactionsPage = () => {
  const {
    content: fileToPrintContent,
    type: fileToPrintType,
    fileName: fileToPrintName,
    isLoading: isFileToPrintLoading,
    isSuccessed: isFileToPrintSuccessed,
    hasError: hasFileToPrintError,
  } = useSelector((state) => state.transactions.consultationTransactions.print);
  const {
    content: consultationTransactionsList,
    totalElements: consultationTransactionsListTotalElements,
    isLoading: isConsultationTransactionsListLoading,
  } = useSelector(
    (state) =>
      state.transactions.consultationTransactions.consultationTransactionsList
  );

  const {
    isLoading: isAnnulationTransactionLoading,
    isSuccessed: isAnnulationTransactionSuccessed,
    hasError: hasAnnulationTransactionError,
  } = useSelector(
    (state) => state.transactions.consultationTransactions.annulationTransaction
  );
  const NavigationActions = () => {
    return (
      <PuiGrid container>
        <PuiGrid item>
          <AppButton
            align="left"
            loading={isFileToPrintLoading}
            disabled={isConsultationTransactionsListLoading}
            loadingPosition="start"
            startIcon={<FileDownloadIcon />}
            color="tertiary"
            onClick={excelExportHandler}
          >
            Extraire
          </AppButton>
        </PuiGrid>
      </PuiGrid>
    );
  };

  const dispatch = useDispatch();

  const alertDispatch = useAlert();

  const formRef = React.useRef();
  const annulationFormRef = React.useRef();

  const [annulationState, annulationStateDispatch] = React.useReducer(
    annulationReducer,
    annulationInitialState
  );

  const [paginationState, changePage] = usePagination(10);

  const [OperateurField, setOperateurField] = React.useState(
    <AppTextField label="Opérateur" disabled />
  );

  const [filtersState, setFiltersState] = React.useState({
    ...consultationTransactionsInitialValues,
  });

  const [rolesOperateurOptions] = useLocalReferentiel([
    localReferentielKeys.ROLES_OPERATEUR_LOCAL_REFERENTIEL_KEY,
  ]);

  const annulationTransactionHandler = (row) => {
    console.log("Transaction to cancel:", row);
    annulationStateDispatch({
      type: OPEN_ANNULATION_DIALOG_REDUCER_TYPE,
      transactionToCancel: row,
    });
    
    // Tentative de définir une valeur par défaut pour le motif d'annulation
    setTimeout(() => {
      if (annulationFormRef.current) {
        annulationFormRef.current.setFieldValue(
          consultationTransactionsFormNames.ANNULATION_MOTIF_ANNULATION_FORM_NAME,
          "1" // Utilisez l'ID du premier motif d'annulation de votre liste
        );
        console.log("Default cancellation reason set to 1");
      }
    }, 500);
  };

  const cancelAnnulationHandler = () => {
    annulationStateDispatch({ type: CLOSE_ANNULATION_DIALOG_REDUCER_TYPE });
  };

  const pageChangeHandler = (pageNumber) => {
    changePage(pageNumber);
  };

  const annulationSubmitHandler = (values) => {
    console.log("Annulation submit handler called with values:", values);
    if (!values.idMotifAnnulation) {
      alertDispatch("error", "Veuillez sélectionner un motif d'annulation");
      return;
    }
    
    // Utiliser l'id de la transaction
    const payload = {
      idTransaction: annulationState.transactionToCancel?.id,
      idMotifAnnulation: values.idMotifAnnulation
    };
    
    console.log("Dispatching with payload:", payload);
    dispatch(annulationTransactionAction(payload));
  };

  const submitHandler = (values) => {
    setFiltersState(values);
    changePage(0);
  };
  const { user } = useSelector((state) => state.auth.login);

  React.useEffect(() => {
    if (hasFileToPrintError) {
      dispatch(printReinitialization());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasFileToPrintError]);

  React.useEffect(() => {
    if (isFileToPrintSuccessed) {
      download(
        `data:${`${fileToPrintType.type}/${fileToPrintType.subtype}`};base64,${fileToPrintContent}`,
        fileToPrintName,
        `${fileToPrintType.type}/${fileToPrintType.subtype}`
      );
      dispatch(printReinitialization());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFileToPrintSuccessed]);

  const tableActions = React.useMemo(() => {
    if (!user.roles.includes("ROLE_VUPORTUARIA_ADMIN_TARIF")) return [];

    return [
      <PuiTableAction
        title="Annuler"
        hideFunc={(row) => row.statutTransaction !== "Décomptée"}
        onClick={annulationTransactionHandler}
      >
        <ClearIcon />
      </PuiTableAction>,
    ];
  }, [user.roles]);

  const getTransactions = () => {
    dispatch(
      getConsultationTransactionsListAction({
        ...filtersState,
        ...paginationState,
      })
    );
  };
  const excelExportHandler = () => {
    dispatch(
      excelExport({
        ...filtersState,
        ...paginationState,
      })
    );
  };
  React.useEffect(() => {
    getTransactions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersState, paginationState]);

  React.useEffect(() => {
    if (hasAnnulationTransactionError) {
      console.log("Annulation transaction error occurred!");
      dispatch(annulationTransactionReinitializationAction());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasAnnulationTransactionError]);

  React.useEffect(() => {
    if (isAnnulationTransactionSuccessed) {
      console.log("Annulation transaction succeeded!");
      annulationFormRef.current?.resetForm();
      annulationStateDispatch({ type: CLOSE_ANNULATION_DIALOG_REDUCER_TYPE });
      getTransactions();
      dispatch(annulationTransactionReinitializationAction());
      alertDispatch("success", "Transaction annulée avec succès.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAnnulationTransactionSuccessed]);

  const roleOperateurChangeHandler = (roleOperateur) => {
    formRef?.current.setFieldValue(
      consultationTransactionsFormNames.OPERATEUR_FORM_NAME,
      ""
    );
    const roleOperateurCode = roleOperateur?.code;
    let InputToRender;
    switch (roleOperateurCode) {
      case "ROLE_VUPORTUARIA_CONSIGNATARIO":
        InputToRender = (
          <AppSpecificReferentielField
            title="Recherche de consignataires"
            searchKey="CONSIGNATAIRES"
            label="Consignataire"
            getRenderedValue={(row) => row.description}
            getReturnedValue={(row) => row.id}
          />
        );
        break;
      case "ROLE_VUPORTUARIA_OPERADOR":
        InputToRender = (
          <AppSpecificReferentielField
            title="Recherche d'opérateurs"
            searchKey="OPERATEURS_MANUTENTION"
            label="Opérateur"
            getRenderedValue={(row) => row.description}
            getReturnedValue={(row) => row.id}
          />
        );
        break;
      case "ROLE_VUPORTUARIA_ANP":
        InputToRender = (
          <AppSimplePopupReferentielField
            title="Recherche de ports"
            searchKey="LISTE_PORTS"
            label="Port"
            descriptionLabel="Nom"
            getRenderedValue={(row) => row.description}
            getReturnedValue={(row) => row.id}
          />
        );
        break;
      case "ROLE_VUPORTUARIA_TRANSITARIO":
        InputToRender = (
          <AppSpecificReferentielField
            title="Recherche de transitaires"
            searchKey="TRANSITAIRES"
            label="Transitaire"
            getRenderedValue={(row) => row.description}
            getReturnedValue={(row) => row.id}
          />
        );
        break;
      case "ROLE_VUPORTUARIA_IMPORTADOR":
        InputToRender = (
          <AppSpecificReferentielField
            title="Recherche d'importateurs"
            searchKey="OPERATEURS_IMP_EXP"
            label="Importateur"
            getRenderedValue={(row) => row.description}
            getReturnedValue={(row) => row.id}
          />
        );
        break;
      case "ROLE_VUPORTUARIA_BANCO":
        InputToRender = (
          <AppSimplePopupReferentielField
            title="Recherche de banques"
            searchKey="LISTE_BANQUES"
            descriptionLabel="Banque"
            label="Banque"
            getRenderedValue={(row) => row.description}
            getReturnedValue={(row) => row.id}
          />
        );
        break;
      default:
        InputToRender = <AppTextField label="Opérateur" disabled />;
        break;
    }
    setOperateurField(InputToRender);
  };

  return (
    <>
      <HistoriqueSouscription />
      <PuiSearchPage
        formik
        formikProps={{
          initialValues: consultationTransactionsInitialValues,
          validationSchema: consultationTransactionsValidationSchema,
          innerRef: formRef,
          onSubmit: submitHandler,
        }}
        title="Consultation des transactions"
        titleIcon={<FormatListBulletedIcon />}
        trace={["Accueil", "Consultation des transactions"]}
        loading={isAnnulationTransactionLoading}
        topNav
        navActions={<NavigationActions />}
        retour={false}
        tableProps={{
          columns:  user.roles.includes("ROLE_VUPORTUARIA_ADMIN_TARIF")?consultationTransactionsTableColumns:consultationTransactionsTableColumns.filter(column => column.field !== "role"),
          rows: consultationTransactionsList,
          rowCount: consultationTransactionsListTotalElements,
          loading: isConsultationTransactionsListLoading,
          actions: tableActions,
          page: paginationState.page,
          pageSize: paginationState.size,
          onPageChange: pageChangeHandler,
          oneActionOnly: true,
        }}
      >
        <PuiGrid container>
          {(user.roles.includes("ROLE_VUPORTUARIA_ADMIN_TARIF") || user.roles.includes("ROLE_VUPORTUARIA_ADMIN"))&&  (
            <>
              <PuiGrid item xs={12} sm={4} md={4}>
                <AppAutocomplete
                  label="Rôle de l'opérateur"
                  name={
                    consultationTransactionsFormNames.ROLE_OPERATEUR_FORM_NAME
                  }
                  options={rolesOperateurOptions.content}
                  loading={rolesOperateurOptions.isLoading}
                  error={rolesOperateurOptions.hasError}
                  helperText={rolesOperateurOptions.error}
                  getOptionLabel={(option) => option.description}
                  getOptionValue={(option) => option.id}
                  onChange={roleOperateurChangeHandler}
                />
              </PuiGrid>
              <PuiGrid item xs={12} sm={4} md={4}>
                {React.cloneElement(OperateurField, {
                  name: consultationTransactionsFormNames.OPERATEUR_FORM_NAME,
                })}
              </PuiGrid>
              <PuiGrid item xs={12} sm={4} md={4}>
                <AppTextField
                  label="Utilisateur"
                  name={consultationTransactionsFormNames.UTILISATEUR_FORM_NAME}
                />
              </PuiGrid>
            </>
          )}
          <PuiGrid item xs={12} sm={4} md={4}>
            <AppTextField
              label="ID de la transaction"
              name={consultationTransactionsFormNames.ID_TRANSACTION_FORM_NAME}
            />
          </PuiGrid>
          <PuiGrid item xs={12} sm={4} md={4}>
            <AppSimpleReferentielField
              autocomplete
              searchKey="LISTE_CRITERES_FACTURATION"
              label="Critère de facturation"
              name={
                consultationTransactionsFormNames.CRITERE_FACTURATION_FORM_NAME
              }
              getOptionLabel={(option) => option.description}
              getOptionValue={(option) => option.code}
            />
          </PuiGrid>
          <PuiGrid item xs={12} sm={4} md={4}>
            <AppTextField
              label="Référence déclencheur"
              name={
                consultationTransactionsFormNames.REFERENCE_DECLENCHEUR_FORM_NAME
              }
            />
          </PuiGrid>
          <PuiGrid item xs={12} sm={4} md={4}>
            <AppSimpleReferentielField
              autocomplete
              searchKey="LISTE_STATUT_TRANSACTION"
              label="Statut de la transaction"
              name={
                consultationTransactionsFormNames.STATUT_TRANSACTION_FORM_NAME
              }
              getOptionLabel={(option) => option.description}
              getOptionValue={(option) => option.code}
              filterFunc={(option) => option.code !== "DELETED"}
            />
          </PuiGrid>
          <PuiGrid item xs={12} sm={4} md={4}>
            <AppSimpleReferentielField
              autocomplete
              label="Code package"
              name={consultationTransactionsFormNames.CODE_PACKAGE_FORM_NAME}
              searchKey="LISTE_TARIFICATION_PACKAGE"
              getOptionLabel={(row) => row.description}
              getOptionValue={(row) => row.description}
            />
          </PuiGrid>
          <PuiGrid item xs={12} sm={4} md={4}>
            <AppTextField
              label="N° de la souscription"
              name={
                consultationTransactionsFormNames.NUMERO_SOUSCRIPTION_FORM_NAME
              }
            />
          </PuiGrid>
          <PuiGrid item xs={12} sm={4} md={4}>
            <AppSimpleReferentielField
              label="Motif d'annulation"
              name={
                consultationTransactionsFormNames.MOTIF_ANNULATION_FORM_NAME
              }
              searchKey="LISTE_MOTIF_ANNULATION"
              getOptionLabel={(row) => row.description}
              getOptionValue={(row) => row.id}
            />
          </PuiGrid>
          <PuiGrid item xs={12} sm={4} md={4}>
            <AppDateField
              label="Date de"
              name={consultationTransactionsFormNames.DATE_DE_FORM_NAME}
            />
          </PuiGrid>
          <PuiGrid item xs={12} sm={4} md={4}>
            <AppDateField
              label="Date à"
              name={consultationTransactionsFormNames.DATE_A_FORM_NAME}
            />
          </PuiGrid>
        </PuiGrid>
      </PuiSearchPage>
      <AppDialog
        title="Confirmer l'annulation de la transaction"
        open={annulationState.isAnnulationDialogOpen}
        loading={isAnnulationTransactionLoading}
      >
        <AppSection>
          <Formik
            initialValues={{
              ...annulationTransactionInitialValues,
            }}
            innerRef={annulationFormRef}
            validationSchema={annulationTransactionValidationSchema}
            onSubmit={annulationSubmitHandler}
            enableReinitialize
          >
            {({ submitForm }) => (
              <Form>
                <PuiGrid container>
                  <PuiGrid item xs={12} sm={6} md={6}>
                    <AppTextField
                      formik={false}
                      label="Code package"
                      value={
                        annulationState.transactionToCancel?.codePackage ?? ""
                      }
                      disabled
                    />
                  </PuiGrid>
                  <PuiGrid item xs={12} sm={6} md={6}>
                    <AppTextField
                      formik={false}
                      label="N° de la souscription"
                      value={
                        annulationState.transactionToCancel
                          ?.numeroSouscription ?? ""
                      }
                      disabled
                    />
                  </PuiGrid>
                  <PuiGrid item xs={12} sm={6} md={6}>
                    <AppTextField
                      formik={false}
                      label="ID de la transaction"
                      value={
                        annulationState.transactionToCancel
                          ?.identifiantTransaction ?? ""
                      }
                      disabled
                    />
                  </PuiGrid>
                  <PuiGrid item xs={12} sm={6} md={6}>
                    <AppSimpleReferentielField
                      label="Motif d'annulation"
                      name={
                        consultationTransactionsFormNames.ANNULATION_MOTIF_ANNULATION_FORM_NAME
                      }
                      searchKey="LISTE_MOTIF_ANNULATION"
                      getOptionLabel={(row) => row.description}
                      getOptionValue={(row) => row.id}
                    />
                  </PuiGrid>
                  <PuiGrid item xs={12}>
                    <PuiGrid container justifyContent="flex-end">
                      <PuiGrid item>
                        <AppButton
                          color="tertiary"
                          onClick={cancelAnnulationHandler}
                        >
                          Annuler
                        </AppButton>
                      </PuiGrid>
                      <PuiGrid item>
                        <AppButton 
                          onClick={() => {
                            console.log("Valider button clicked");
                            submitForm();
                          }}
                          loading={isAnnulationTransactionLoading}
                          disabled={isAnnulationTransactionLoading}
                        >Valider</AppButton>
                      </PuiGrid>
                    </PuiGrid>
                  </PuiGrid>
                </PuiGrid>
              </Form>
            )}
          </Formik>
        </AppSection>
      </AppDialog>
    </>
  );
};

export default ConsultationTransactionsPage;
